import { Sparkles } from "lucide-react";

const items = [
  "0% commission",
  "Free to list",
  "Concierge-guided",
  "Verified buyers",
  "Real-time offers",
  "Closing support",
  "Save $22k+ on average",
  "No agent required",
];

const SavingsBar = () => {
  return (
    <div className="relative bg-canvas-deep border-y border-ink/8 overflow-hidden">
      <div className="flex animate-marquee whitespace-nowrap py-5">
        {[...items, ...items].map((text, i) => (
          <div key={i} className="flex items-center gap-4 px-8 text-sm">
            <Sparkles className="w-3 h-3 text-gold-deep" strokeWidth={1.5} />
            <span className="text-ink-soft font-light tracking-wide">{text}</span>
            <span className="text-gold-deep font-light">·</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SavingsBar;
